/**
 * EventCard Component
 * 
 * Reusable component for displaying wedding events with consistent styling.
 * Used across HomePage, MainAgenda, Wedding, and Reception pages.
 */

import React from 'react';

/**
 * EventCard component for displaying individual wedding events
 * @param {Object} event - Event data object
 * @param {boolean} isReversed - Whether to reverse the layout (image on right)
 * @returns {JSX.Element} - Rendered event card
 */
const EventCard = ({ event, isReversed = false }) => {
  const {
    title,
    date,
    time,
    venue,
    attire,
    description,
    image,
    flower
  } = event;

  return (
    <div className={`event ${isReversed ? 'reversed' : ''}`}>
      <div className="event-content">
        {/* Event Image */}
        <img 
          src={image} 
          alt={title}
          className="event-image"
        />
        
        {/* Event Details */}
        <div className="event-details">
          <h2>{title}</h2>
          <p><strong>Date:</strong> {date}</p>
          <p><strong>Time:</strong> {time}</p>
          <p><strong>Venue:</strong> {venue}</p>
          <p><strong>Attire:</strong> {attire}</p>
          <p className="description">{description}</p>
        </div>
      </div>
      
      {/* Flower Decoration */}
      {flower && (
        <div className="flower-container">
          <div className="flower-line"></div>
          <img 
            src={flower} 
            alt="Flower decoration" 
            className="flower-decoration"
          />
          <div className="flower-line"></div>
        </div>
      )}
    </div>
  );
};

export default EventCard;